"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
exports.HighCharts = exports.GraphicsAdapter = void 0;
// let Highcharts = require('highcharts/highstock');
var addTablePy_1 = require("./addTablePy");
var basic_chart_component_1 = require("../../../../basic-component/basic-chart.component");
var GraphicsAdapter = /** @class */ (function () {
    function GraphicsAdapter(type, chartName, chartSettings, chartTimestamp) {
        if (chartTimestamp === void 0) { chartTimestamp = '-'; }
        this.type = type;
        this.chartName = chartName;
        this.chartTimestamp = chartTimestamp;
        this.prevOrientation = null;
        this.prevType = null;
        this.chartSettings = chartSettings;
        this.chartSettings.showTooltip = this.chartSettings.showTooltip == "true" || this.chartSettings.showTooltip == true;
        this.chartSettings.showLabels = this.chartSettings.showLabels == "true" || this.chartSettings.showLabels == true;
    }
    GraphicsAdapter.prototype.setup = function (data, orientation) {
        this.orientation = orientation;
        this.setupAdapterWith(data);
    };
    GraphicsAdapter.prototype.setupAdapterWith = function (data) {
        throw "Cannot call setupAdapterWith(data) on Abstract Class GraphicsAdapter";
    };
    GraphicsAdapter.prototype.setType = function (type, orientation) {
        this.type = type;
        this.orientation = orientation;
        this.applyTypeAndOrientation();
        this.prevOrientation = orientation;
        this.prevType = type;
    };
    GraphicsAdapter.prototype.setUseOffsetWidth = function (val) {
        this.useOffsetWidth = val;
    };
    GraphicsAdapter.prototype.applyTypeAndOrientation = function () {
        throw "Cannot call applyTypeAndOrientation() on Abstract Class GraphicsAdapter";
    };
    GraphicsAdapter.prototype.drawOn = function (elementName, type) {
        this.drawChartOn(elementName, type);
    };
    GraphicsAdapter.prototype.drawChartOn = function (elementName, type) {
        throw "Cannot call drawChartOn(elementName, type) on Abstract Class GraphicsAdapter";
    };
    GraphicsAdapter.prototype.initializeVisibility = function (attr, enabledOrder) {
        // this.inverted = false;
        // if (this.type === "line") {
        //     this.series[this.series.length - 1][attr] = enabledOrder;
        // } else {
        this.series[0][attr] = enabledOrder;
        // }
    };
    return GraphicsAdapter;
}());
exports.GraphicsAdapter = GraphicsAdapter;
var NVD3Charts = /** @class */ (function (_super) {
    __extends(NVD3Charts, _super);
    function NVD3Charts() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NVD3Charts.prototype.setupAdapterWith = function (data) {
        this.flipMatrix = {
            "horizontal-line": {
                "vertical-line": true,
                "horizontal-bar": false
            },
            "vertical-line": {
                "horizontal-line": true,
                "vertical-bar": true
            },
            "horizontal-bar": {
                "horizontal-line": false,
                "vertical-bar": false
            },
            "vertical-bar": {
                "vertical-line": true,
                "horizontal-bar": false
            }
        };
        var matrix = new addTablePy_1.Matrix(data);
        matrix = matrix.transpose();
        var series = [];
        for (var i = 1; i < matrix.data.length; i++) {
            var key = matrix.data[i][0];
            var values = [];
            for (var j = 1; j < matrix.data[i].length; j++) {
                values.push({
                    x: matrix.data[0][j],
                    y: matrix.data[i][j]
                });
            }
            series.push({
                key: key,
                values: values,
                disabled: true
            });
        }
        this.series = series;
        this.initializeVisibility("disabled", false);
    };
    NVD3Charts.prototype.flip = function () {
        for (var i = 0; i < this.series.length; i++) {
            for (var j = 0; j < this.series[i].values.length; j++) {
                var oldY = this.series[i].values[j].y;
                this.series[i].values[j].y = this.series[i].values[j].x;
                this.series[i].values[j].x = oldY;
            }
        }
    };
    NVD3Charts.prototype.applyTypeAndOrientation = function () {
        if (this.prevOrientation === null) {
            return;
        }
        var currKey = this.orientation + "-" + this.type;
        var prevKey = this.prevOrientation + "-" + this.prevType;
        if (this.flipMatrix[prevKey][currKey] === true) {
            this.flip();
        }
    };
    NVD3Charts.prototype.drawChartOn = function (elementName, type) {
        console.warn("Calling deprecated function.");
        var data = this.series;
        var orientation = this.orientation;
        var svgElement = $('#' + elementName + ' svg');
        if (svgElement.length === 0) {
            $('#' + elementName).append('<svg>');
        }
        nv.addGraph(function () {
            $('#' + elementName + ' svg').empty();
            if (type === "line") {
                var chart = nv.models.lineChart()
                    .useInteractiveGuideline(true);
            }
            else {
                if (orientation === "vertical") {
                    var chart = nv.models.multiBarHorizontalChart();
                }
                else {
                    var chart = nv.models.multiBarChart();
                }
            }
            chart.xAxis
                .axisLabel('Year')
                .tickPadding(7);
            chart.yAxis
                .axisLabel('');
            d3.select('#' + elementName + ' svg')
                .datum(data)
                .transition().duration(500)
                .call(chart);
            nv.utils.windowResize(function () {
                chart.update();
            });
            return chart;
        });
    };
    return NVD3Charts;
}(GraphicsAdapter));
var HighCharts = /** @class */ (function (_super) {
    __extends(HighCharts, _super);
    function HighCharts() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HighCharts.prototype.setupAdapterWith = function (data) {
        var series = [];
        if (this.type === "pie") {
            series = [{
                    name: data[1][0],
                    colorByPoint: true,
                    data: []
                }];
            for (var i = 0; i < data[0].length - 1; i++) {
                series[0].data.push({
                    name: data[0][i + 1],
                    y: Number(data[1][i + 1])
                });
            }
            this.series = series;
        }
        else if (this.type === "scatter") {
            var matrix = new addTablePy_1.Matrix(data);
            matrix = matrix.transpose();
            this.xName = matrix.data[0][1];
            this.yName = matrix.data[0][2];
            for (var i = 1; i < matrix.data.length; i++) {
                series.push({
                    name: matrix.data[i][0],
                    data: [[Number(matrix.data[i][1]), Number(matrix.data[i][2])]],
                    marker: {
                        symbol: 'circle'
                    }
                });
            }
            this.series = series;
        }
        else if (this.type === "bubble") {
            var matrix = new addTablePy_1.Matrix(data);
            matrix = matrix.transpose();
            this.xName = matrix.data[0][1];
            this.yName = matrix.data[0][2];
            this.zName = matrix.data[0][3];
            series = [{ data: [] }];
            for (var i = 1; i < matrix.data.length; i++) {
                series[0].data.push({
                    name: matrix.data[i][0],
                    x: Number(matrix.data[i][1]),
                    y: Number(matrix.data[i][2]),
                    z: Number(matrix.data[i][3])
                });
            }
            this.series = series;
        }
        else {
            var matrix = new addTablePy_1.Matrix(data);
            matrix = matrix.transpose();
            this.yLabels = matrix.data[0];
            this.yLabels.splice(0, 1);
            for (var i = 1; i < matrix.data.length; i++) {
                var name_1 = matrix.data[i][0];
                var dataPoints = matrix.data[i];
                dataPoints.splice(0, 1);
                var entry = {
                    name: name_1,
                    data: dataPoints.map(function (d) { return ({ y: d }); }),
                    visible: false
                };
                series.push(entry);
            }
            this.series = series;
        }
        this.setType(this.type, this.orientation);
        this.initializeVisibility("visible", true);
    };
    HighCharts.prototype.applyTypeAndOrientation = function () {
        this.height = 450;
        this.width = 1000;
        if (this.type === "pie") {
            this.chartType = "pie";
        }
        else if (this.type == "scatter") {
            this.chartType = "scatter";
        }
        else if (this.type === "bubble") {
            this.chartType = "bubble";
        }
        else if (this.type === "line") {
            this.chartType = "spline";
            this.inverted = this.orientation === "vertical";
        }
        else {
            this.inverted = false;
            if (this.orientation === "vertical") {
                this.chartType = "bar";
                this.height = 300 + this.series[0].data.length / 50 * 800;
            }
            else {
                this.chartType = "column";
                if (300 + this.series[0].data.length / 50 * 1200 > 1000) {
                    this.width = 300 + this.series[0].data.length / 50 * 1200;
                }
            }
        }
        console.log("Changing to: " + this.type + ", " + this.orientation + ", processed change as: " + this.chartType + ", inverted: " + this.inverted);
    };
    HighCharts.prototype.applyDrillDownData = function (drillDownDataDict) {
        this.drillDownDataDict = drillDownDataDict;
        this.series.forEach(function (s) {
            if (s.name in drillDownDataDict) {
                s.data.forEach(function (d) { return (d['drilldown'] = true); });
            }
        });
    };
    HighCharts.prototype.drawChartOn = function (elementName, type) {
        var ctrl = angular.copy(this);
        var chartDetails = {
            chart: {
                renderTo: elementName,
                type: ctrl.chartType,
                inverted: ctrl.inverted,
                height: ctrl.height,
                width: ctrl.useOffsetWidth ? null : ctrl.width,
                zoomType: 'xy'
            },
            credits: {
                enabled: false
            },
            tooltip: {
                enabled: ctrl.chartSettings.showTooltip,
                crosshairs: [true],
                shared: true,
                formatter: function () {
                    var tooltip = "<b>" + this.x + "</b>";
                    for (var i = 0; i < this.points.length; i++) {
                        tooltip += "<br />" + this.points[i].series.name + ": <i>" + this.points[i].y.toFixed(ctrl.chartSettings.decimals) + "</i>";
                    }
                    return tooltip;
                }
            },
            title: {
                text: ctrl.chartName,
                x: -20 //center
            },
            legend: {
                layout: 'vertical',
                align: 'right',
                verticalAlign: 'middle',
                borderWidth: 1
            },
            series: ctrl.series
        };
        if (ctrl.type !== "pie") {
            chartDetails['xAxis'] = {
                categories: ctrl.yLabels
            };
            chartDetails['yAxis'] = {
                title: {
                    text: ''
                },
                plotLines: [{
                        value: 0,
                        width: 1,
                        color: '#808080'
                    }]
            };
            if (ctrl.type == "scatter" || ctrl.type == "bubble") {
                chartDetails = setAxis(chartDetails, 'xAxis', ctrl.xName);
                chartDetails = setAxis(chartDetails, 'yAxis', ctrl.yName);
            }
        }
        function setAxis(chartDetails, axis, title) {
            chartDetails[axis]['plotLines'] = [{
                    value: 0,
                    color: 'black',
                    width: 2,
                    zIndex: 2
                }];
            chartDetails[axis]['title'] = {
                enabled: true,
                text: title
            };
            return chartDetails;
        }
        if (ctrl.type == "bubble") {
            chartDetails['tooltip'] = {
                enabled: ctrl.chartSettings.showTooltip,
                formatter: function () {
                    return "<b>" + this.point.name + "</b> <br />" +
                        (ctrl.xName + ": <i>" + this.point.x.toFixed(ctrl.chartSettings.decimals) + "</i><br />") +
                        (ctrl.yName + ": <i>" + this.point.y.toFixed(ctrl.chartSettings.decimals) + "</i><br />") +
                        (ctrl.zName + ": <i>" + this.point.z.toFixed(ctrl.chartSettings.decimals) + "</i>");
                }
            };
            chartDetails['legend'] = { enabled: false };
            chartDetails['plotOptions'] = {
                bubble: {
                    dataLabels: {
                        enabled: ctrl.chartSettings.showLabels,
                        align: 'right',
                        style: {
                            fontWeight: 'thin',
                            color: 'black'
                        },
                        formatter: function () {
                            return this.point.name.slice(0, ctrl.chartSettings.charsInLabel);
                        }
                    }
                }
            };
        }
        else if (ctrl.type == "scatter") {
            chartDetails['plotOptions'] = {
                series: {
                    color: '#538DCF'
                }
            };
            chartDetails['tooltip'] = {
                enabled: ctrl.chartSettings.showTooltip,
                formatter: function () {
                    return "<b>" + this.series.name + "</b> <br />" +
                        (ctrl.xName + ": <i>" + this.point.x.toFixed(ctrl.chartSettings.decimals) + "</i><br />") +
                        (ctrl.yName + ": <i>" + this.point.y.toFixed(ctrl.chartSettings.decimals) + "</i>");
                }
            };
            chartDetails['legend'] = { enabled: false };
            chartDetails['plotOptions'] = {
                scatter: {
                    dataLabels: {
                        enabled: ctrl.chartSettings.showLabels,
                        align: 'right',
                        style: {
                            fontWeight: 'thin',
                            color: 'black'
                        },
                        formatter: function () {
                            return this.series.name.slice(0, ctrl.chartSettings.charsInLabel);
                        }
                    }
                }
            };
        }
        else if (ctrl.type == "pie") {
            chartDetails['tooltip'] = {
                enabled: ctrl.chartSettings.showTooltip,
                formatter: function () {
                    return this.series.name + " : <i>" + this.point.percentage.toFixed(ctrl.chartSettings.decimals) + "%</i>";
                }
            };
        }
        if (ctrl.drillDownDataDict) {
            // add drill down to chart
            if (!chartDetails['chart']['events']) {
                chartDetails['chart']['events'] = {};
            }
            chartDetails['chart']['events']['drilldown'] = function (e) {
                if (!e.seriesOptions) {
                    var chart_1 = this;
                    var series = ctrl.drillDownDataDict[e.point.series.name];
                    if (series) {
                        for (var _i = 0, series_1 = series; _i < series_1.length; _i++) {
                            var s = series_1[_i];
                            chart_1.addSingleSeriesAsDrilldown(e.point, s);
                        }
                    }
                    chart_1.applyDrilldown();
                }
            };
            // add area config for drill down to plotOptions
            if (!chartDetails['plotOptions']) {
                chartDetails['plotOptions'] = {};
            }
            chartDetails['plotOptions']['area'] = {
                stacking: 'normal',
                marker: {
                    enabled: false,
                    symbol: 'circle',
                    radius: 4,
                    states: {
                        hover: {
                            enabled: true
                        }
                    }
                }
            };
        }
        var chart = new Highcharts.Chart(chartDetails, function (chart) {
            // chart.renderer.text(ctrl.chartName, ctrl.width - 150, ctrl.height - 17)
            //     .css({
            //         color: '#939294',
            //         fontSize: '10px'
            //     })
            //     .add();
            var timestamp = ctrl.chartSettings.timestampMode === 'lastRecalc' ? (0, basic_chart_component_1.getDate)(ctrl.chartTimestamp) : (0, basic_chart_component_1.getDate)();
            chart.renderer.text(timestamp, ctrl.width - 140, ctrl.height - 2)
                .css({
                color: '#939294',
                fontSize: '10px'
            })
                .add();
        });
    };
    return HighCharts;
}(GraphicsAdapter));
exports.HighCharts = HighCharts;
exports["default"] = GraphicsAdapter;
//# sourceMappingURL=graphicsAdapters.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/add-tables/app/js/logic/graphicsAdapters.js